import {dataConstants} from '../constants'

const eventcategoryinitialState = {
    fetchingEventCategory: true,
    deletingEventCategory: true,
    eventCategorylist: [],
    errors: [],
}

const seteventcategoryinitialState = {
    loadingSetEventCategory: true,
    eventcategory: {},
    errors: [],
}

const eventoccurrencesinitialState = {
    loadingEventOccurrences: false,
    deletingEventOccurrences: false,
    eventoccurrences: [],
    fetchingEventOccurSwipers: false,
    eventoccurrenceswipers: [],
    errors: [],
}

const eventinitialState = {
    fetchingEvents: true,
    eventlist: [],
    errors: [],
}

const occurinitialState = {
    loadingOccurrence: false,
    occurrence: {},
    errors: [],
}

const lookupinitialState = {
    fetchingLookupResults: false,
    lookupParams: {},
    lookupresult: {},
    errors: [],
}

const lookupEUIDinitialState = {
    fetchingLookupResults: false,
    lookupEUID: '',
    lookupEUIDresult: {},
    errors: [],
}

const swipeinitialState = {
    fetchingSwipeResult: false,
    swiperesult: {},
    errors: [],
}

const batchswipeinitialState = {
    fetchingSwipeResult: false,
    fetchingSwipedEmplids: false,
    batchswiperesult: {},
    emplidsswiped: [],
    errors: [],
}

const swipeteaminitialState = {
    fetchingSwipeTeams: false,
    deletingSwipeTeams: false,
    swipeteams: {},
    currentswipeteam: {},
    errors: [],
}

const engagementtypeinitialState = {
    fetchingEngagementtypes: true,
    engagementtypelist: [],
    errors: [],
}

const departmentsinitialState = {
    fetchingDepartments: true,
    settingManageRoleDept: false,
    deletingDepartments: false,
    departmentslist: [],
    manageroledept: {},
    activedepartment: '',
    errors: [],
}

const departmentusersinitialState = {
    fetchingDepartmentUsers: false,
    deletingDepartmentUsers: false,
    addingDepartmentUsers: false,
    departmentuserslist: [],
    errors: [],
}

const superadminsinitialState = {
    fetchingAllusers: false,
    fetchingSuperadmins: false,
    puttingSuperadmin: false,
    superadminslist: [],
    allusers: [],
    errors: [],
}

export function eventcategorydata(state = eventcategoryinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_EVENTCATEGORY_REQUEST:
        case dataConstants.DATA_ADDEVTCATEGORY_REQUEST:
        case dataConstants.DATA_UPDATEEVTCATEGORY_REQUEST:
            return {...state, fetchingEventCategory: true, errors: []}
        case dataConstants.DATA_DELEVTCATEGORY_REQUEST:
            return {...state, deletingEventCategory: true, errors: []}
        case dataConstants.DATA_EVENTCATEGORY_SUCCESS:
            return {
                ...state,
                eventCategorylist: action.data.events ? action.data.events : [],
                fetchingEventCategory: false,
            }
        case dataConstants.DATA_ADDEVTCATEGORY_SUCCESS:
            return {
                ...state,
                eventCategorylist: state.eventCategorylist.concat(action.data),
                fetchingEventCategory: false,
            }
        case dataConstants.DATA_UPDATEEVTCATEGORY_SUCCESS:
            return {
                ...state,
                eventCategorylist: state.eventCategorylist.map(item => {
                    if (item.id === action.data.id) return action.data

                    return item
                }),
                fetchingEventCategory: false,
            }
        case dataConstants.DATA_DELEVTCATEGORY_SUCCESS:
            return {
                ...state,
                deletingEventCategory: false,
            }
        case dataConstants.DATA_EVENTCATEGORY_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingEventCategory: false,
                eventCategorylist: [],
            }
        case dataConstants.DATA_ADDEVTCATEGORY_FAILURE:
        case dataConstants.DATA_UPDATEEVTCATEGORY_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingEventCategory: false,
            }
        case dataConstants.DATA_DELEVTCATEGORY_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                deletingEventCategory: false,
            }
        default:
            return state
    }
}

export function seteventcategorydata(
    state = seteventcategoryinitialState,
    action
) {
    switch (action.type) {
        case dataConstants.DATA_SETEVTCATEGORY_REQUEST:
            return {
                ...state,
                loadingSetEventCategory: true,
                eventcategory: {},
                errors: [],
            }
        case dataConstants.DATA_SETEVTCATEGORY_SUCCESS:
            return {
                ...state,
                eventcategory: action.eventcategory,
                loadingSetEventCategory: false,
            }
        case dataConstants.DATA_SETEVTCATEGORY_CLEAR:
            return {
                ...state,
                eventcategory: action.eventcategory,
                loadingSetEventCategory: false,
            }
        case dataConstants.DATA_SETEVTCATEGORY_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                loadingSetEventCategory: false,
                eventcategory: {},
            }
        default:
            return state
    }
}

export function eventoccurrencesdata(
    state = eventoccurrencesinitialState,
    action
) {
    switch (action.type) {
        case dataConstants.DATA_GETEVTOCCURRENCES_REQUEST:
        case dataConstants.DATA_ADDEVTOCCURRENCES_REQUEST:
        case dataConstants.DATA_UPDEVTOCCURRENCES_REQUEST:
            return {
                ...state,
                loadingEventOccurrences: true,
                errors: [],
            }
        case dataConstants.DATA_DELEVTOCCURRENCES_REQUEST:
            return {
                ...state,
                deletingEventOccurrences: true,
                loadingEventOccurrences: true,
                errors: [],
            }
        case dataConstants.DATA_GETEVTOCCURSWIPERS_REQUEST:
        case dataConstants.DATA_UPDEVTOCCURSWIPERS_REQUEST:
            return {
                ...state,
                fetchingEventOccurSwipers: true,
                errors: [],
            }
        case dataConstants.DATA_BATCHSWIPERECORD_REQUEST:
            return {
                ...state,
                eventoccurrences: state.eventoccurrences.map(item => {
                    if (
                        item.occurId === action.occurId &&
                        item.eventId === action.eventId
                    ) {
                        return {
                            ...item,
                            swipeCount: item.swipeCount,
                            prevswipeCount: item.swipeCount,
                            loadingRecordSwipeResults: true,
                        } //action.data
                    } else {
                        return {
                            ...item,
                            swipeCount: item.swipeCount,
                            prevswipeCount: item.swipeCount,
                            loadingRecordSwipeResults: false,
                        }
                    }
                }),
            }
        case dataConstants.DATA_GETEVTOCCURSWIPERS_SUCCESS:
        case dataConstants.DATA_UPDEVTOCCURSWIPERS_SUCCESS:
            return {
                ...state,
                eventoccurrenceswipers: action.data.swipers,
                fetchingEventOccurSwipers: false,
            }
        case dataConstants.DATA_GETEVTOCCURRENCES_SUCCESS:
            return {
                ...state,
                eventoccurrences: action.data.occurrences,
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_ADDEVTOCCURRENCES_SUCCESS:
            return {
                ...state,
                eventoccurrences:
                    state.eventoccurrences.length > 0
                        ? state.eventoccurrences[0].eventId ===
                          action.data.eventId
                            ? state.eventoccurrences.concat(action.data)
                            : state.eventoccurrences
                        : state.eventoccurrences.concat(action.data),
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_UPDEVTOCCURRENCES_SUCCESS:
            return {
                ...state,
                eventoccurrences: state.eventoccurrences.map(item => {
                    if (item.occurId === action.data.occurId) return action.data

                    return item
                }),
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_BATCHSWIPERECORD_SUCCESS:
            return {
                ...state,
                eventoccurrences: state.eventoccurrences.map(item => {
                    if (
                        item.occurId === action.data.occurId &&
                        item.eventId === action.data.eventId
                    ) {
                        return {
                            ...item,
                            swipeCount: action.data.swipeCount,
                            prevswipeCount: item.swipeCount,
                            loadingRecordSwipeResults: false,
                        } //action.data
                    } else {
                        return {
                            ...item,
                            swipeCount: item.swipeCount,
                            prevswipeCount: item.swipeCount,
                        }
                    }
                    //return item
                }),
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_DELEVTOCCURRENCES_SUCCESS:
            return {
                ...state,
                deletingEventOccurrences: false,
            }
        case dataConstants.DATA_GETEVTOCCURRENCES_CLEAR:
            return {
                ...state,
                eventoccurrences: action.eventoccurrence,
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_GETEVTOCCURSWIPERS_CLEAR:
            return {
                ...state,
                eventoccurrenceswipers: [],
                fetchingEventOccurSwipers: false,
            }
        case dataConstants.DATA_GETEVTOCCURRENCES_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                loadingEventOccurrences: false,
                eventoccurrences: [],
            }
        case dataConstants.DATA_GETEVTOCCURSWIPERS_FAILURE:
        case dataConstants.DATA_UPDEVTOCCURSWIPERS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                eventoccurrenceswipers: [],
                fetchingEventOccurSwipers: false,
            }
        case dataConstants.DATA_ADDEVTOCCURRENCES_FAILURE:
        case dataConstants.DATA_UPDEVTOCCURRENCES_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                loadingEventOccurrences: false,
            }
        case dataConstants.DATA_DELEVTOCCURRENCES_FAILURE:
            return {
                ...state,
                deletingEventOccurrences: false,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
            }
        default:
            return state
    }
}

export function eventdata(state = eventinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_EVENT_REQUEST:
            return {...state, fetchingEvents: true, errors: []}
        case dataConstants.DATA_EVENT_SUCCESS:
            return {
                ...state,
                eventlist: action.data.occurrences,
                fetchingEvents: false,
            }
        case dataConstants.DATA_EVENT_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingEvents: false,
                eventlist: [],
            }
        default:
            return state
    }
}

export function occurrencedata(state = occurinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_OCCURRENCES_REQUEST:
            return {
                ...state,
                loadingOccurrence: true,
                occurrence: {},
                errors: [],
            }
        case dataConstants.DATA_OCCURRENCES_SUCCESS:
            return {
                ...state,
                occurrence: action.data,
                loadingOccurrence: false,
            }
        case dataConstants.DATA_OCCURRENCES_CLEAR:
            return {
                ...state,
                occurrence: action.occurrence,
                loadingOccurrence: false,
            }
        case dataConstants.DATA_OCCURRENCES_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                loadingOccurrence: false,
                occurrence: {},
            }
        case dataConstants.DATA_SWIPE_SUCCESS:
            return {
                ...state,
                occurrence: {
                    ...state.occurrence,
                    swipeCount: action.data.swipeCount,
                },
            }
        default:
            return state
    }
}

export function lookupdata(state = lookupinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_LOOKUP_REQUEST:
            return {
                ...state,
                fetchingLookupResults: true,
                lookupParams: action.values,
                lookupresult: {},
                errors: [],
            }
        case dataConstants.DATA_LOOKUP_SUCCESS:
            return {
                ...state,
                lookupresult: action.data.persons,
                fetchingLookupResults: false,
            }
        case dataConstants.DATA_LOOKUP_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingLookupResults: false,
                lookupresult: {},
            }
        case dataConstants.DATA_LOOKUP_CLEARPARAMS:
            return {
                ...state,
                lookupParams: {},
                fetchingLookupResults: false,
            }
        case dataConstants.DATA_LOOKUP_CLEARRESULTS:
            return {
                ...state,
                lookupresult: {},
                fetchingLookupResults: false,
            }
        default:
            return state
    }
}

export function lookupEUIDdata(state = lookupEUIDinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_LOOKUPEUID_REQUEST:
            return {
                ...state,
                fetchingLookupResults: true,
                lookupEUID: action.euid,
                lookupEUIDresult: {},
                errors: [],
            }
        case dataConstants.DATA_LOOKUPEUID_SUCCESS:
            return {
                ...state,
                lookupEUIDresult: action.data,
                fetchingLookupResults: false,
            }
        case dataConstants.DATA_LOOKUPEUID_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingLookupResults: false,
                lookupEUIDresult: {},
            }
        case dataConstants.DATA_LOOKUPEUID_CLEARRESULTS:
            return {
                ...state,
                lookupEUID: '',
                lookupEUIDresult: {},
                fetchingLookupResults: false,
            }
        default:
            return state
    }
}

export function swipedata(state = swipeinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_SWIPE_REQUEST:
            return {
                ...state,
                fetchingSwipeResult: true,
                swiperesult: {},
                errors: [],
            }
        case dataConstants.DATA_SWIPE_SUCCESS:
            return {
                ...state,
                swiperesult: action.data,
                fetchingSwipeResult: false,
            }
        case dataConstants.DATA_SWIPE_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipeResult: false,
                swiperesult: {},
            }
        case dataConstants.DATA_OCCURRENCES_REQUEST:
            return {...state, swiperesult: {}, errors: []}
        default:
            return state
    }
}

export function batchswipedata(state = batchswipeinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_BATCHSWIPEVALIDATE_REQUEST:
        case dataConstants.DATA_BATCHSWIPERECORD_REQUEST:
            return {
                ...state,
                fetchingSwipeResult: true,
                batchswiperesult: {},
                errors: [],
            }
        case dataConstants.DATA_GETBATCHSWIPEEMPLIDS_REQUEST:
            return {
                ...state,
                fetchingSwipedEmplids: true,
                emplidsswiped: [],
                errors: [],
            }
        case dataConstants.DATA_BATCHSWIPEVALIDATE_SUCCESS:
        case dataConstants.DATA_BATCHSWIPERECORD_SUCCESS:
            return {
                ...state,
                batchswiperesult: action.data,
                fetchingSwipeResult: false,
            }
        case dataConstants.DATA_GETBATCHSWIPEEMPLIDS_SUCCESS:
            return {
                ...state,
                emplidsswiped: action.data.emplids,
                fetchingSwipedEmplids: false,
            }
        case dataConstants.DATA_BATCHSWIPEVALIDATE_FAILURE:
        case dataConstants.DATA_BATCHSWIPERECORD_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipeResult: false,
                batchswiperesult: {},
            }
        case dataConstants.DATA_GETBATCHSWIPEEMPLIDS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipedEmplids: false,
                emplidsswiped: [],
            }
        case dataConstants.DATA_BATCHSWIPEVALIDATE_CLEAR:
            return {
                ...state,
                batchswiperesult: {},
                emplidsswiped: [],
                fetchingSwipeResult: false,
                fetchingSwipedEmplids: false,
            }
        default:
            return state
    }
}

export function swipeteamdata(state = swipeteaminitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_GETSWIPETEAMS_REQUEST:
        case dataConstants.DATA_ADDSWIPETEAM_REQUEST:
        case dataConstants.DATA_UPDATESWIPETEAM_REQUEST:
            return {...state, fetchingSwipeTeams: true, errors: []}
        case dataConstants.DATA_DELETESWIPETEAM_REQUEST:
            return {
                ...state,
                deletingSwipeTeams: true,
                fetchingSwipeTeams: true,
                errors: [],
            }
        case dataConstants.DATA_GETDEPTSWIPETEAM_REQUEST:
            return {...state, errors: []}
        case dataConstants.DATA_GETSWIPETEAMS_SUCCESS:
            return {
                ...state,
                swipeteams: action.data.swipeLists,
                fetchingSwipeTeams: false,
            }
        case dataConstants.DATA_GETDEPTSWIPETEAM_SUCCESS:
            return {
                ...state,
                currentswipeteam: action.data,
                fetchingSwipeTeams: false,
            }
        case dataConstants.DATA_ADDSWIPETEAM_SUCCESS:
            return {
                ...state,
                swipeteams: state.swipeteams.concat(action.data),
                fetchingSwipeTeams: false,
            }
        case dataConstants.DATA_UPDATESWIPETEAM_SUCCESS:
            return {
                ...state,
                swipeteams: state.swipeteams.map(item => {
                    if (item.listId === action.data.listId) return action.data

                    return item
                }),
                fetchingSwipeTeams: false,
            }

        case dataConstants.DATA_DELETESWIPETEAM_SUCCESS:
            return {
                ...state,
                deletingSwipeTeams: false,
            }

        case dataConstants.DATA_GETSWIPETEAMS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipeTeams: false,
                swipeteams: [],
            }
        case dataConstants.DATA_GETDEPTSWIPETEAM_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipeTeams: false,
                currentswipeteam: {},
            }
        case dataConstants.DATA_ADDSWIPETEAM_FAILURE:
        case dataConstants.DATA_UPDATESWIPETEAM_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingSwipeTeams: false,
            }
        case dataConstants.DATA_GETDEPTSWIPETEAM_CLEARRESULTS:
            return {
                ...state,
                currentswipeteam: {},
            }

        case dataConstants.DATA_DELETESWIPETEAM_FAILURE:
            return {
                ...state,
                deletingSwipeTeams: false,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
            }
        default:
            return state
    }
}

export function engagementtypedata(state = engagementtypeinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_ENGAGEMENTTYPE_REQUEST:
            return {...state, fetchingEngagementtypes: true, errors: []}
        case dataConstants.DATA_ENGAGEMENTTYPE_SUCCESS:
            return {
                ...state,
                engagementtypelist: action.data.engagements,
                fetchingEngagementtypes: false,
            }
        case dataConstants.DATA_ENGAGEMENTTYPE_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingEngagementtypes: false,
                engagementtypelist: [],
            }
        default:
            return state
    }
}

export function departmentsdata(state = departmentsinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_DEPARTMENTS_REQUEST:
        case dataConstants.DATA_SETACTDEPARTMENT_REQUEST:
        case dataConstants.DATA_ADDMANAGEROLEDEPT_REQUEST:
        case dataConstants.DATA_UPDMANAGEROLEDEPT_REQUEST:
            return {...state, fetchingDepartments: true, errors: []}
        case dataConstants.DATA_DELMANAGEROLEDEPT_REQUEST:
            return {...state, deletingDepartments: true, errors: []}
        case dataConstants.DATA_SETMANAGEROLEDEPT_REQUEST:
            return {...state, settingManageRoleDept: true, errors: []}
        case dataConstants.DATA_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                departmentslist: action.data.departments,
                fetchingDepartments: false,
            }
        case dataConstants.DATA_SETACTDEPARTMENT_SUCCESS:
            return {
                ...state,
                activedepartment: action.activedepartment,
                fetchingDepartments: false,
            }
        case dataConstants.DATA_SETMANAGEROLEDEPT_SUCCESS:
        case dataConstants.DATA_SETMANAGEROLEDEPT_CLEAR:
            return {
                ...state,
                manageroledept: action.manageroledept,
                settingManageRoleDept: false,
            }
        case dataConstants.DATA_ADDMANAGEROLEDEPT_SUCCESS:
            return {
                ...state,
                departmentslist: state.departmentslist.concat(action.data),
                fetchingDepartments: false,
            }
        case dataConstants.DATA_UPDMANAGEROLEDEPT_SUCCESS:
            return {
                ...state,
                departmentslist: state.departmentslist.map(item => {
                    if (item.deptId === action.data.deptId) return action.data

                    return item
                }),
                fetchingDepartments: false,
            }
        case dataConstants.DATA_DELMANAGEROLEDEPT_SUCCESS:
            return {...state, deletingDepartments: false}
        case dataConstants.DATA_DEPARTMENTS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingDepartments: false,
                departmentlist: [],
            }
        case dataConstants.DATA_ADDMANAGEROLEDEPT_FAILURE:
        case dataConstants.DATA_UPDMANAGEROLEDEPT_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingDepartments: false,
            }
        case dataConstants.DATA_DELMANAGEROLEDEPT_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                deletingDepartments: false,
            }
        case dataConstants.DATA_SETACTDEPARTMENT_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingDepartments: false,
                activedepartment: '',
            }
        case dataConstants.DATA_SETMANAGEROLEDEPT_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                manageroledept: {},
                settingManageRoleDept: false,
            }
        default:
            return state
    }
}

export function departmentusersdata(
    state = departmentusersinitialState,
    action
) {
    switch (action.type) {
        case dataConstants.DATA_GETDEPARTMENTUSERS_REQUEST:
        case dataConstants.DATA_UPDDEPARTMENTUSERS_REQUEST:
            return {
                ...state,
                fetchingDepartmentUsers: true,
                errors: [],
            }
        case dataConstants.DATA_ADDDEPARTMENTUSERS_REQUEST:
            return {
                ...state,
                addingDepartmentUsers: true,
                errors: [],
            }
        case dataConstants.DATA_DELDEPARTMENTUSERS_REQUEST:
            return {
                ...state,
                deletingDepartmentUsers: true,
                fetchingDepartmentUsers: true,
                errors: [],
            }
        case dataConstants.DATA_GETDEPARTMENTUSERS_SUCCESS:
            return {
                ...state,
                departmentuserslist: action.data.users,
                fetchingDepartmentUsers: false,
            }
        case dataConstants.DATA_ADDDEPARTMENTUSERS_SUCCESS:
            return {
                ...state,
                //departmentuserslist: state.departmentuserslist.concat(action.data),
                addingDepartmentUsers: false,
            }
        case dataConstants.DATA_UPDDEPARTMENTUSERS_SUCCESS:
            return {
                ...state,
                departmentuserslist: state.departmentuserslist.map(item => {
                    if (item.euid === action.data.euid)
                        return {...item, ...action.data}

                    return item
                }),
                fetchingDepartmentUsers: false,
            }
        case dataConstants.DATA_DELDEPARTMENTUSERS_SUCCESS:
            return {
                ...state,
                deletingDepartmentUsers: false,
            }
        case dataConstants.DATA_GETDEPARTMENTUSERS_CLEAR:
            return {
                ...state,
                departmentuserslist: action.departmentusers,
                fetchingDepartmentUsers: false,
            }
        case dataConstants.DATA_GETDEPARTMENTUSERS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingDepartmentUsers: false,
                departmentuserslist: [],
            }
        case dataConstants.DATA_ADDDEPARTMENTUSERS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                addingDepartmentUsers: false,
            }
        case dataConstants.DATA_UPDDEPARTMENTUSERS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingDepartmentUsers: false,
            }
        case dataConstants.DATA_DELDEPARTMENTUSERS_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                deletingDepartmentUsers: false,
            }
        default:
            return state
    }
}

export function superadminsdata(state = superadminsinitialState, action) {
    switch (action.type) {
        case dataConstants.DATA_GETALLUSERS_REQUEST:
            return {...state, fetchingAllusers: true, errors: []}
        case dataConstants.DATA_GETSUPERADMINS_REQUEST:
            return {...state, fetchingSuperadmins: true, errors: []}
        case dataConstants.DATA_PUTSUPERADMIN_REQUEST:
            return {...state, puttingSuperadmin: true, errors: []}
        case dataConstants.DATA_GETALLUSERS_SUCCESS:
            return {
                ...state,
                allusers: action.data.users,
                fetchingAllusers: false,
            }
        case dataConstants.DATA_GETSUPERADMINS_SUCCESS:
            return {
                ...state,
                superadminslist: action.data.users,
                fetchingSuperadmins: false,
            }
        case dataConstants.DATA_GETALLUSERS_FAILURE:
        case dataConstants.DATA_GETSUPERADMINS_FAILURE:
        case dataConstants.DATA_PUTSUPERADMIN_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingAllusers: false,
                fetchingSuperadmins: false,
                puttingSuperadmin: false,
                superadminslist: [],
                allusers: [],
            }
        case dataConstants.DATA_PUTSUPERADMIN_SUCCESS:
            return {
                ...state,
                puttingSuperadmin: false,
            }
        case dataConstants.DATA_GETALLUSERS_CLEAR:
            return {
                ...state,
                allusers: action.allusers,
                fetchingAllusers: false,
            }
        default:
            return state
    }
}
